// extracted by mini-css-extract-plugin
module.exports = {"container":"PrimaryInformation_container__2n12G","divider":"PrimaryInformation_divider__1k9rw"};